import NextdoorPixel from './NextdoorPixel';

export default NextdoorPixel;
